import { render, staticRenderFns } from "./PrintHeader.vue?vue&type=template&id=718b2986&scoped=true"
import script from "./PrintHeader.vue?vue&type=script&lang=js"
export * from "./PrintHeader.vue?vue&type=script&lang=js"
import style0 from "./PrintHeader.vue?vue&type=style&index=0&id=718b2986&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b2986",
  null
  
)

export default component.exports